import { i as r } from "./is-array.js";
import { l as o } from "./length-of-array-like.js";
import { d as t } from "./does-not-exceed-safe-integer.js";
import { f as a } from "./function-bind-context.js";
var e = function e(n, f, i, s, m, p, c, d) {
    for (var j, l, u = m, x = 0, y = !!c && a(c, d); x < s;) x in i && (j = y ? y(i[x], x, f) : i[x], p > 0 && r(j) ? (l = o(j), u = e(n, f, j, l, u, p - 1) - 1) : (t(u + 1), n[u] = j), u++), x++;
    return u;
  },
  n = e;
export { n as f };